import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { isNullOrUndefined, UserNotFoundException } from '@uzurv/core';
// eslint-disable-next-line import/order
import { UzurvRestConfiguration, UzurvRestService, UZURV_REST_CONFIGURATION } from '@uzurv/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PasswordService extends UzurvRestService {
  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  /**
   * Requests a password reset interaction for the given user
   *
   * @param username
   */
  forgotPassword(username: string): Observable<boolean> {
    return this.get('resetPassword/requestReset', { username: username })
      .pipe(map(() => true))
      .pipe(
        catchError(err => {
          const message = isNullOrUndefined(err.message) ? '' : err.message;

          if (message.includes('User with username') && message.includes('not found')) {
            return throwError(new UserNotFoundException(message));
          }

          return throwError(err);
        })
      );
  }

  /**
   * Validates the given password
   *
   * @param password
   */
  validatePassword(password: string): Observable<boolean> {
    return this.get('validatePassword', { password: password }).pipe(map(() => true));
  }

  /**
   * Updates the password for an authorized user
   *
   * @param token
   * @param newPassword
   * @param confirmPassword
   */
  changePassword(token: string, newPassword: string, confirmPassword: string): Observable<boolean> {
    const body = {
      token: token,
      newPassword: newPassword,
      confirmPassword: confirmPassword
    };

    return this.post(`resetPassword/`, body).pipe(map(() => true));
  }
}
